function Image({ url, className, alt, allLoaded }) {
  const onLoad = () => {
    allLoaded(true);
  };
  return <img src={url} onLoad={onLoad} className={className} alt={alt} />;
}
export default Image;
